import { render, staticRenderFns } from "./would-i-be-suited-to.vue?vue&type=template&id=a2e5f642&"
import script from "./would-i-be-suited-to.vue?vue&type=script&lang=js&"
export * from "./would-i-be-suited-to.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports